<svg id="uuid-ea2584ef-d37a-4a9c-901c-8ca80b412a4e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <defs>
        <style>.uuid-feb447ea-c2f9-4b57-9059-1640878fd994{fill:#f6b800;stroke-width:0px;}</style>
    </defs>
    <path class="uuid-feb447ea-c2f9-4b57-9059-1640878fd994" d="M320,0c35.3,0,64,28.7,64,64v384c0,35.3-28.7,64-64,64H64c-35.3,0-64-28.7-64-64V64C0,28.7,28.7,0,64,0h256Z"/>
</svg>